import React from "react";
import { useDispatch } from "react-redux";
import { formSet } from "../../actions/appActions";
import { initialMemberField } from "../../constants/factories";
import { AddCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
import { TYPE_MEMBER_FIELD } from "../../api/api";
import MemberFieldList from "./MemberFieldList";

const MemberField = () => {
  const dispatch = useDispatch();

  const handleCreate = () => {
    dispatch(formSet(TYPE_MEMBER_FIELD, { ...initialMemberField }));
  };

  return (
    <>
      <Button
        sx={{ mt: 2, mb: 2 }}
        onClick={handleCreate}
        color="primary"
        variant="contained"
        disableElevation
        startIcon={<AddCircle />}
      >
        Vytvořit novou vlastnost
      </Button>
      <MemberFieldList />
    </>
  );
};

export default MemberField;
